module.exports = __webpack_public_path__ + "static/img/cuelist.8600fc3.png";


//////////////////
// WEBPACK FOOTER
// ./sample/assets/img/cuelist.png
// module id = 294
// module chunks = 2